import React, { useState } from "react";
import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import theme from "../../../theme/Theme";
import { WalletConnection } from "../../../service/WalletConnection";
import WalletModal from "../../../component/WalletModal";
import { useHookstate } from "@hookstate/core";
import { metaMaskState } from "../../../hooks/store";
import bannerImage from "../../../assets/images/referral-earning_banner.webp";

const HeroSection = () => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const metamaskState = useHookstate(metaMaskState);
  const {
    connectedAddress,
    handleConnectWalletPress,
    handleWalletConnect,
    handleDisconnect,
  } = WalletConnection();
  const theme = useTheme();

  const handleWalletSelect = async (walletType, connectors) => {
    const result = await handleWalletConnect(walletType, connectors);
    if (result.status === "success") {
      navigate("/dashboard/referrals");
    }
  };

  return (
    <Box sx={styles.heroSection}>
      <Box sx={styles.heroOverlay} />
      <Container maxWidth="lg">
        <Box sx={styles.heroContent}>
          <Typography variant="h1" sx={styles.heroTitle}>
            Your Audience Pays
          </Typography>
          <Typography variant="h2" sx={styles.heroSubtitle}>
            Earn USDT Instantly by Promoting the Most Transparent Draw System
            Ever
          </Typography>
          <Box
            sx={styles.buttonWrapper}
            onClick={() => navigate("/referrals")}
            role="button"
            aria-label={
              connectedAddress
                ? "View My Referrals"
                : "Connect Wallet & Get My Link Now"
            }
          >
            <Box sx={styles.buttonContainer}>
              <Typography sx={styles.buttonText}>
                {connectedAddress
                  ? "View My Referrals"
                  : "Connect Wallet & Get My Link Now"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>

      <WalletModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        onWalletSelect={handleWalletSelect}
      />
    </Box>
  );
};

const styles = {
  heroSection: {
    textAlign: "left",
    padding: {
      xs: "80px 16px",
      sm: "120px 24px",
      md: "160px 32px",
    },
    color: theme.palette.common.white,
    position: "relative",
    overflow: "hidden",
    backgroundImage: `url(${bannerImage})`,
    backgroundSize: "cover",
    // backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: { xs: "500px", sm: "600px", md: "700px" },
    display: "flex",
    alignItems: "center",
  },
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: {
      xs: "linear-gradient(to right, rgba(191, 20, 34, 0.9) 0%, rgba(220,20,60,0.7) 100%)",
      sm: "linear-gradient(to right, rgba(191, 20, 34, 0.9) 10%, rgba(220,20,60,0.5) 80%)",
      md: "linear-gradient(to right, rgba(191, 20, 34, 1) 20%, rgba(220,20,60,0.3) 70%, rgba(220,20,60,0) 100%)",
    },
    zIndex: 0,
  },
  heroContent: {
    maxWidth: { xs: "100%", sm: "80%", md: "600px" },
    position: "relative",
    zIndex: 1,
  },
  heroTitle: {
    fontSize: {
      xs: "2.5rem",
      sm: "3rem",
      md: "3.5rem",
      lg: "4rem",
    },
    lineHeight: { xs: 1.2, md: 1.1 },
    fontWeight: 800,
    marginBottom: { xs: "16px", md: "20px" },
    fontFamily: '"Proxima Nova", sans-serif',
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  heroSubtitle: {
    fontSize: {
      xs: "1.1rem",
      sm: "1.3rem",
      md: "1.5rem",
      lg: "1.8rem",
    },
    lineHeight: { xs: 1.4, md: 1.3 },
    fontWeight: 400,
    marginBottom: { xs: "40px", md: "60px" },
    fontFamily: '"Proxima Nova", sans-serif',
    opacity: 0.9,
    color: theme.palette.common.white,
  },
  buttonWrapper: {
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: "12px",
    padding: "0.15em",
    width: "fit-content",
    maxWidth: "100%",
    marginTop: { xs: "0.4em", sm: "1em", md: "1.5em" },
    marginBottom: "1em",
    transition: "transform 0.2s ease",
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.02)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  },
  buttonContainer: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    padding: { xs: "12px 16px", sm: "14px 20px", md: "16px 24px" },
    borderRadius: "10px",
    color: theme.palette.common.white,
    fontSize: { xs: "0.875rem", sm: "1rem" },
    fontWeight: 600,
    textTransform: "uppercase",
    textAlign: "center",
    minHeight: { xs: "40px", sm: "48px" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  },
  buttonText: {
    color: theme.palette.common.white,
    fontSize: "inherit",
    fontWeight: "inherit",
    textTransform: "inherit",
    textAlign: "center",
  },
};

export default HeroSection;
